export const environment = {
  production: false,
  local: false,
  URL_AI: 'https://famulusaiapi.rrsolutionstest.it/api/v1',
  URL_BASE: 'https://famulusbackend.rrsolutionstest.it/api/v1',
  URL_IMAGES: 'https://famulusimages.rrsolutionstest.it/',
  URL_CHATBOT: 'https://famuluschatbot.rrsolutionstest.it/',
  CLIENT_URL_BASE: 'https://famulususer.rrsolutionstest.it/',
  COOKIE_DOMAIN: '.rrsolutionstest.it',
  turnstileSiteKey: '0x4AAAAAACTPRDDfaielARd7'
};
